import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom";
import './Players.sass'
import { TrendingUp } from "lucide-react";



export default function Players() {
    // Fetch signed in players league
    const { leagueId } = useParams();
    const navigate = useNavigate();

    const [players, setPlayers] = useState([]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(`/api/league/${leagueId}/players`)

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                let data = await res.json();
                console.log(data)
                setPlayers(data)

            } catch (err) {
                console.log("Failed to fetch league posts.", err)
            }

        }
        fetchData();

    }, [])

    const onClick = (player) => {
        console.log(player)
        if (player.id) {
            let path = `/league/${leagueId}/player/${player.id}`
            navigate(path, {
                state: {
                    player: {
                        id: player.id,
                        firstName: player.firstName,
                        lastName: player.lastName,
                        avatar: player.avatar,
                        joinedAt: player.joinedAt
                    }
                }
            });
        }
    }



    const playerCard = ({ player }) => {
        return
        //<a key={`${player.firstName}_${index}`} className="player-card" href={`/league/${leagueId}/player/${player.id}`}></a>
    }
    return (


        <div className="players-container">
            {players.map((player, index) => {
                if (player?.active === false) return null;
                return (
                    <div key={`${player.firstName}_${index}`} className="player-card">

                        <div className="player-card--image">
                            <img src={player?.avatar?.url ? player?.avatar?.url : "https://storage.googleapis.com/threeputt-api.firebasestorage.app/players/b80469b1-8aee-43f1-b849-15c409ba90bf/avatar-1773758210609.jpg"} alt={player.firstName} />
                        </div>
                        <div className="player-card--content">
                            <h3 className="player-card--name">{player.firstName}  {player.lastName}</h3>
                            <button
                                className="button"
                                onClick={() => onClick(player)}
                            >
                                STATS <span className="icon"><TrendingUp size={16} /></span>
                            </button>
                        </div>

                    </div>
                )
            })}

        </div >


    )
}
